var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"media":"(max-width: 1023px)","srcset":_vm.getSrc('mobile')}}),_c('img',{attrs:{"media":"(min-width: 1024px)","srcset":_vm.getSrc('desktop')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }